
import { Text } from "@twilio-paste/text";
import { Box } from "@twilio-paste/box";
import { FC } from "react";
import { useNotifiedContext } from "../../../hooks/useNotifiedContext/useNotifiedContext";
import { useAppState } from "../../../hooks/useAppState/useAppState";
import { ProcessNeutralIcon } from "@twilio-paste/icons/esm/ProcessNeutralIcon";
import { ProcessSuccessIcon } from "@twilio-paste/icons/esm/ProcessSuccessIcon";

export const ConferenceAlert: FC = () => {
	const { conference } = useNotifiedContext();
	const { appState } = useAppState();
	return (
		<Box width="100%">
			{(conference?.conferenceType === "mainRoom") && appState.isRoomOpen ?
				<Box display="flex" alignItems="center" columnGap="space10">
					<ProcessSuccessIcon
						color="colorTextIconError"
						decorative={false}
						title="warning"
						size="sizeIcon80" />
					<Box>
						<Text as="p" fontSize="fontSize40">
							<b>You are currently Live.</b>
						</Text>
						<Text as="p" fontSize="fontSize20">
						All parties can now hear you.
						</Text>
					</Box>
				</Box>
				:
				<Box display="flex" alignItems="center" columnGap="space10">
					<ProcessNeutralIcon
						color="colorTextIconNeutral"
						decorative={false}
						title="neutral"
						size="sizeIcon80"/>
					<Box>
						<Text as="p" fontSize="fontSize30">
							<b>You are currently in the Pre-Call Lobby. </b>
						</Text>
						<Text as="p" fontSize="fontSize20">
						Only the host and speakers can hear you.
						</Text>
					</Box>
				</Box>}
		</Box>
	);
};